import api from './HttpService';
import { PAYMENT } from '../configs/ApiActionUrl';

async function getAll(pageOption, sortData, department, client, status, keyword, rangeDate) {
  let query = '';

  if (pageOption) {
    const { page, pageSize } = pageOption;
    if (page !== undefined && pageSize !== undefined) {
      query = `?page=${page + 1}&limit=${pageSize}`;
    }
  }

  if (sortData) {
    const { sortField, sort } = sortData;
    if (sortField && sort) {
      query += `&sort_by=${sortField}&order_by=${sort}`;
    }
  }

  if (department) {
    query += `&department_filter=${department}`;
  }

  if (client) {
    query += `&client_filter=${client}`;
  }

  if (status) {
    query += `&payment_status=${status}`;
  }

  if (keyword) {
    query += `&search_key=${keyword}`;
  }

  if (rangeDate) {
    const { dateStart, dateEnd } = rangeDate;
    if (dateStart && dateEnd) {
      query += `&from_date=${dateStart}&to_date=${dateEnd}`;
    }
  }

  try {
    const res = await api.get(PAYMENT.LIST + query);
    return res;
  } catch (error) {
    return error; // Rethrow the error to propagate it further
  }
}

async function add(postData) {
  const res = await api.post(PAYMENT.ADD, postData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res;
}

async function getItem(code) {
  const res = await api.get(`${PAYMENT.EDIT}/${code}`);
  return res;
}

async function update(code, postData) {
  const res = await api.post(`${PAYMENT.UPDATE}/${code}`, postData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res;
}

async function deleteItem(code) {
  const res = await api.delete(`${PAYMENT.DELETE}/${code}`);
  return res;
}

async function getPaymentFilter() {
  const res = await api.get(`${PAYMENT.GET_LIST_FILTER}`);
  return res;
}

async function getInvoiceNumber(Id = '') {
  const url = Id ? `${PAYMENT.GET_INVOICE_NUMBER}/${Id}` : `${PAYMENT.GET_INVOICE_NUMBER}`;

  const res = await api.get(url);
  return res;
}

async function getPaymentMethod() {
  const res = await api.get(`${PAYMENT.GET_PAYMENT_VIA}`);
  return res;
}

async function getPaymentType() {
  const res = await api.get(`${PAYMENT.GET_PAYMENT_TYPE}`);
  return res;
}

async function updatePreview(code, postData) {
  const res = await api.patch(`${PAYMENT.UPDATE_PREVIEW}/${code}`, postData);
  return res;
}

async function resendInvoice(code) {
  const res = await api.get(`${PAYMENT.RESEND}/${code}`);
  return res;
}

async function reminderInvoice(code) {
  const res = await api.get(`${PAYMENT.REMINDER}/${code}`);
  return res;
}

async function copyInvoice(code) {
  const res = await api.get(`${PAYMENT.COPY}/${code}`);
  return res;
}

async function deleteTimeSheet(code) {
  const res = await api.delete(`${PAYMENT.DELETE_TIMESHEET}/${code}`);
  return res;
}
// async function getAllTransaction(pageOption, sort, method, type, department, keyword) {
//   const res = await api.get(`${PAYMENT.GET_ALL_TRANSACTION}`);
//   return res;
// }

async function getAllTransaction(pageOption, sortData, method, type, status, keyword, rangeDate) {
  let query = '';

  if (pageOption) {
    const { page, pageSize } = pageOption;
    if (page !== undefined && pageSize !== undefined) {
      query = `?page=${page + 1}&limit=${pageSize}`;
    }
  }

  if (sortData) {
    const { sortField, sort } = sortData;
    if (sortField && sort) {
      query += `&sort_by=${sortField}&order_by=${sort}`;
    }
  }

  if (method) {
    query += `&payment_gateway=${method}`;
  }

  if (type) {
    query += `&type=${type}`;
  }

  if (status) {
    query += `&status=${status}`;
  }

  if (keyword) {
    query += `&search_key=${keyword}`;
  }

  if (rangeDate) {
    const { dateStart, dateEnd } = rangeDate;
    if (dateStart && dateEnd) {
      query += `&from_date=${dateStart}&to_date=${dateEnd}`;
    }
  }

  try {
    const res = await api.get(PAYMENT.GET_ALL_TRANSACTION + query);
    return res;
  } catch (error) {
    return error; // Rethrow the error to propagate it further
  }
}

async function getTransactionItem(code) {
  const res = await api.get(`${PAYMENT.GET_TRANSACTION_ITEM}/${code}`);
  return res;
}

async function getTransactionStatus() {
  const res = await api.get(`${PAYMENT.GET_TRANSACTION_STATUS}`);
  return res;
}

async function previewMail(code, postData) {
  const res = await api.post(`${PAYMENT.PREVIEW_MAIL}/${code}`, postData);
  return res;
}

async function sendPreviewMail(code, postData) {
  const res = await api.post(`${PAYMENT.PREVIEW_MAIL_SEND}/${code}`, postData);
  return res;
}

async function getPaymentDatails(code, token) {
  const res = await api.get(`${PAYMENT.GET_PAYMENT_DETAILS}/${code}/${token}`);
  return res;
}

async function generatePaypal(code) {
  const res = await api.get(`${PAYMENT.GENERATE_PAYPAL}/paypal/${code}`);
  return res;
}

async function generateVeem(code) {
  const res = await api.get(`${PAYMENT.GENERATE_VEEM}/veem/${code}`);
  return res;
}

async function updateAuthorizeNet(code, postData) {
  const res = await api.post(`${PAYMENT.AUTHORIZENET}/card/${code}`, postData);
  return res;
}

async function updateStripe(code, postData) {
  const res = await api.post(`${PAYMENT.STRIPE}/create/${code}`, postData);
  return res;
}

async function updateStripeCapture(postData) {
  const res = await api.post(`${PAYMENT.STRIPE}/capture`, postData);
  return res;
}

async function paypalCancel(code) {
  const res = await api.get(`${PAYMENT.PAYPAL_STATUS}/cancel?token=${code}`);
  return res;
}

async function paypalSuccess(code, payerId, invoiceCode) {
  let url = `${PAYMENT.PAYPAL_STATUS}/success?token=${code}&PayerID=${payerId}`;
  if (invoiceCode) {
    url += `&id=${encodeURIComponent(invoiceCode)}`;
  }
  const res = await api.get(url);
  return res;
}

async function getPendingPayment(code) {
  const res = await api.get(`${PAYMENT.GET_PENDING_ITEMS}/${code}`);
  return res;
}

async function getAllManualPayment(pageOption, sortData, method, type, keyword, rangeDate) {
  let query = '';

  if (pageOption) {
    const { page, pageSize } = pageOption;
    if (page !== undefined && pageSize !== undefined) {
      query = `?page=${page + 1}&limit=${pageSize}`;
    }
  }

  if (sortData) {
    const { sortField, sort } = sortData;
    if (sortField && sort) {
      query += `&sort_by=${sortField}&order_by=${sort}`;
    }
  }

  if (method) {
    query += `&payment_gateway=${method}`;
  }

  if (type) {
    query += `&payment_type_name=${type}`;
  }

  if (keyword) {
    query += `&search_key=${keyword}`;
  }

  if (rangeDate) {
    const { dateStart, dateEnd } = rangeDate;
    if (dateStart && dateEnd) {
      query += `&from_date=${dateStart}&to_date=${dateEnd}`;
    }
  }

  try {
    const res = await api.get(PAYMENT.MANUAL_LIST + query);
    return res;
  } catch (error) {
    return error; // Rethrow the error to propagate it further
  }
}

async function addManualPayment(code, type, postData) {
  let res;
  if (type === 'manual') {
    res = await api.post(`${PAYMENT.MANUAL_ADD}/${code}`, postData);
  } else {
    res = await api.post(`${PAYMENT.WRITEOFF_ADD}/${code}`, postData);
  }
  return res;
}

async function getManualPaymentItem(code) {
  const res = await api.get(`${PAYMENT.MANUAL_EDIT}/${code}`);
  return res;
}

async function updateManualPayment(code, postData) {
  const res = await api.patch(`${PAYMENT.MANUAL_UPDATE}/${code}`, postData);
  return res;
}

async function getManualPaymentFilter() {
  const res = await api.get(`${PAYMENT.MANUAL_FILTER}`);
  return res;
}

async function updateCloverCharge(code, postData) {
  const res = await api.post(`${PAYMENT.CLOVER}/${code}`, postData);
  return res;
}

async function getPaymentStatus(code) {
  const res = await api.get(`${PAYMENT.STATUS}/${code}`);
  return res;
}

async function getScheduleCancel(code) {
  const res = await api.get(`${PAYMENT.SCHEDULE_CANCEL}/${code}`);
  return res;
}

const PaymentService = {
  getAll,
  add,
  update,
  getItem,
  deleteItem,
  getInvoiceNumber,
  getPaymentMethod,
  getPaymentType,
  updatePreview,
  resendInvoice,
  copyInvoice,
  getAllTransaction,
  getTransactionItem,
  getTransactionStatus,
  previewMail,
  sendPreviewMail,
  getPaymentDatails,
  generatePaypal,
  updateAuthorizeNet,
  updateStripe,
  updateStripeCapture,
  paypalSuccess,
  paypalCancel,
  getPendingPayment,
  getAllManualPayment,
  addManualPayment,
  updateManualPayment,
  getManualPaymentItem,
  getManualPaymentFilter,
  reminderInvoice,
  deleteTimeSheet,
  getPaymentFilter,
  generateVeem,
  updateCloverCharge,
  getPaymentStatus,
  getScheduleCancel
};

export default PaymentService;
